import { render } from "./ui-select-saerch.vue?vue&type=template&id=20f3e86f&scoped=true&ts=true"
import script from "./ui-select-saerch.vue?vue&type=script&lang=ts"
export * from "./ui-select-saerch.vue?vue&type=script&lang=ts"

import "./ui-select-saerch.vue?vue&type=style&index=0&id=20f3e86f&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f3e86f"]])

export default __exports__